import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"
import { hitUrl } from "@common/lib/util"
import { updateAccountDetails } from "@common/network"

import { getTierData } from "@common/pages/pricing"
import { WorkFlowFooter } from "@common/workflow/workflow"
import Loader from "@common/loader"

import { replacePageKey } from "@common/lib/navigation"
import PricingPlans from "@common/pricingPlans"
import { usePlans } from "@common/context/usePlans"

const OnboardingPlans = ({ buttons, project }) => {
  const router = useRouter()
  const { data, isLoading, isError } = usePlans("manage/tasks", project, 2)

  const [tiers, setTiers] = useState([])
  const [period, setPeriod] = useState(Object.keys(buttons)[0])
  const [selectedPlan, setSelectedPlan] = useState()
  const homePath = replacePageKey(router.asPath, "home")

  useEffect(() => {
    if (data && !isError) {
      const tiers = getTierData(data, null, false)
      const activePlanKey = getActivePlan(tiers)
      setTiers(tiers)
      if (activePlanKey) setSelectedPlan(activePlanKey)
    }
  }, [data, isError])

  const getActivePlan = (tiers) => {
    for (const key in tiers) {
      const tier = tiers[key]
      if (tier.active) {
        return key
      }
    }
  }

  const hasActivePlan = (tiers) => !!getActivePlan(tiers)

  const makePayment = (moveForward, period) => {
    let paymentLink
    if (selectedPlan.includes("trial")) {
      const period = Object.keys(tiers[selectedPlan]["durations"])[0]
      paymentLink = tiers[selectedPlan]["durations"][period]?.href
      hitUrl(paymentLink)
      moveForward()
      return
    }
    paymentLink = tiers[selectedPlan]["durations"][period]?.href
    router.push(paymentLink)
  }

  const handleNextClick = (moveForward, period) => {
    if (hasActivePlan(tiers)) {
      updateAccountDetails({ home_path: homePath })
      moveForward()
    } else makePayment(moveForward, period)
  }

  const handleSelect = (plan) => {
    if (plan) setSelectedPlan(plan)
  }

  if (isLoading)
    return (
      <div className="h-screen-3/4 flex items-center justify-center">
        <Loader />
      </div>
    )

  if (!data || !tiers) return <div></div>

  return (
    <div className="flex flex-col items-center mt-20 ">
      <h2 className="font-bold text-2xl text-center">
        Select a plan that suits you.
      </h2>
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <PricingPlans
          tiers={tiers}
          data={data}
          planPeriodOptions={buttons}
          showPopular={false}
          enableSelection
          period={period}
          setPeriod={setPeriod}
          showSavingMsg={false}
          onSelect={handleSelect}
          defaultSelectedKey={selectedPlan}
          unitType="small"
        />
        <div className="flex justify-end w-full my-16">
          <WorkFlowFooter
            noSubmitMode={true}
            handleNextClick={(moveForward) => handleNextClick(moveForward, period)}
            disabled={!selectedPlan}
          />
        </div>
      </div>
    </div>
  )
}
export default OnboardingPlans
